(()=>{
  const CONTEXT_MAX_AGE=15*60*1000;
  let applying=false;

  const normalize=value=>String(value||"").toLowerCase();
  const safeSessionGet=key=>{try{return sessionStorage.getItem(key)}catch(err){return null}};
  const safeSessionSet=(key,value)=>{try{sessionStorage.setItem(key,value)}catch(err){}};
  const safeLocalSet=(key,value)=>{try{localStorage.setItem(key,value)}catch(err){}};

  function inferAudience(value){
    const text=normalize(value);
    if(text.includes("/collections/womens-fashion")||/\bwomen(?:'s|’s|s)?\b/.test(text)||/women-s/.test(text))return"women";
    if(text.includes("/collections/d-y-l-f-vibes")||/\bmen(?:'s|’s|s)?\b/.test(text)||/men-s/.test(text))return"men";
    if(text.includes("/collections/him-her-you")||/\bunisex\b/.test(text))return"unisex";
    return"";
  }

  function inferCategory(value){
    const text=normalize(value);
    if(/footwear|shoe|shoes|sneaker|sneakers|slip-on|slip on|canvas-shoes/.test(text))return"footwear";
    if(/sweatshirt/.test(text))return"sweatshirt";
    if(/hoodie/.test(text))return"hoodie";
    if(/t-shirt|t shirt|\btee\b|\btees\b/.test(text))return"tee";
    if(/crossbody|sling|tote|\bbag\b|\bbags\b/.test(text))return"bag";
    if(/bucket-hat|bucket hat|snapback|\bhat\b|\bhats\b|\bcap\b|\bcaps\b/.test(text))return"hat";
    if(/bomber|jacket/.test(text))return"jacket";
    if(/dress/.test(text))return"dress";
    if(/bundle|paired/.test(text))return"bundle";
    return"";
  }

  function shopperContext(){
    const params=new URLSearchParams(window.location.search);
    let audience=normalize(params.get("audience"));
    let category=normalize(params.get("category"));
    const referrer=document.referrer||"";

    if(!["women","men","unisex"].includes(audience))audience="";
    if(!audience)audience=inferAudience(referrer);
    if(!category)category=inferCategory(referrer);

    if(audience||category){
      safeSessionSet("qb_vibe_context",JSON.stringify({audience,category,at:Date.now()}));
      return{audience,category};
    }

    try{
      const saved=JSON.parse(safeSessionGet("qb_vibe_context")||"null");
      if(saved&&Date.now()-Number(saved.at||0)<=CONTEXT_MAX_AGE){
        return{audience:saved.audience||"",category:saved.category||""};
      }
    }catch(err){}

    return{audience:"",category:""};
  }

  function productMeta(article,index){
    const title=article.querySelector("h3")?.textContent.trim()||"";
    const price=article.querySelector(".qb-vibe__price")?.textContent.trim()||"";
    const media=article.querySelector(".qb-vibe__product-media");
    const cta=article.querySelector(".qb-vibe__primary");
    const url=media?.getAttribute("href")||cta?.getAttribute("href")||"";
    const image=article.querySelector("img")?.getAttribute("src")||"";
    const descriptor=title+" "+url;
    return{title,price,url,image,index,audience:inferAudience(descriptor),category:inferCategory(descriptor)};
  }

  function score(product,context){
    let points=0;
    if(context.audience){
      if(product.audience===context.audience)points+=100;
      else if(product.audience==="unisex")points+=80;
      else if(!product.audience)points+=65;
    }
    if(context.category&&product.category===context.category)points+=35;
    return points;
  }

  function rankedProducts(products,context){
    let pool=products.slice();

    if(context.audience==="women"){
      const preferred=pool.filter(product=>product.audience!=="men");
      if(preferred.length>=3)pool=preferred;
    }else if(context.audience==="men"){
      const preferred=pool.filter(product=>product.audience!=="women");
      if(preferred.length>=3)pool=preferred;
    }else if(context.audience==="unisex"){
      const preferred=pool.filter(product=>product.audience!=="women"&&product.audience!=="men");
      if(preferred.length>=3)pool=preferred;
    }

    return pool.sort((a,b)=>score(b,context)-score(a,context)||a.index-b.index);
  }

  function escapeHtml(value){
    return String(value||"")
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/\"/g,"&quot;")
      .replace(/'/g,"&#039;");
  }

  function heroCard(product,why){
    const title=escapeHtml(product.title);
    const price=escapeHtml(product.price);
    const url=escapeHtml(product.url);
    const image=escapeHtml(product.image);
    return '<article class="qb-vibe__product qb-vibe__match">'+
      '<a class="qb-vibe__product-media" href="'+url+'"><img src="'+image+'" alt="'+title+'"></a>'+
      '<div class="qb-vibe__product-info">'+
      '<p class="qb-vibe__match-label">PALOMA’S MATCH</p>'+
      '<h3>'+title+'</h3>'+
      '<p class="qb-vibe__price">'+price+'</p>'+
      '<div class="qb-vibe__why"><span>WHY I PICKED IT</span><p>'+escapeHtml(why)+'</p></div>'+
      '<a class="qb-vibe__primary" href="'+url+'">GET INTO IT</a>'+
      '</div></article>';
  }

  function supportingCard(product){
    const title=escapeHtml(product.title);
    const price=escapeHtml(product.price);
    const url=escapeHtml(product.url);
    const image=escapeHtml(product.image);
    return '<article class="qb-vibe__product">'+
      '<a class="qb-vibe__product-media" href="'+url+'"><img src="'+image+'" alt="'+title+'" loading="lazy"></a>'+
      '<div class="qb-vibe__product-info">'+
      '<h3>'+title+'</h3>'+
      '<p class="qb-vibe__price">'+price+'</p>'+
      '<a class="qb-vibe__primary" href="'+url+'">TAKE A LOOK</a>'+
      '</div></article>';
  }

  function productHandle(url){
    const match=String(url||"").match(/\/products\/([^\/?#]+)/);
    return match?match[1]:"";
  }

  function applyContext(){
    if(applying)return;
    const root=document.querySelector(".qb-vibe");
    const result=root?.querySelector("#qb-vibe-result");
    const hero=root?.querySelector("#qb-vibe-hero");
    const grid=root?.querySelector("#qb-vibe-products");
    if(!root||!result||result.hidden||!hero||!grid)return;

    const context=shopperContext();
    if(!context.audience&&!context.category)return;

    const cards=[...hero.querySelectorAll(".qb-vibe__product"),...grid.querySelectorAll(".qb-vibe__product")];
    if(cards.length<2)return;

    const why=hero.querySelector(".qb-vibe__why p")?.textContent.trim()||"";
    const products=cards.map(productMeta);
    const ranked=rankedProducts(products,context);
    if(!ranked.length)return;

    const currentOrder=products.map(product=>product.url).join("|");
    const desiredOrder=ranked.map(product=>product.url).join("|");
    const matchHandle=productHandle(ranked[0].url);
    if(matchHandle)safeLocalSet("qb_vibe_match_handle",matchHandle);
    if(currentOrder===desiredOrder)return;

    applying=true;
    hero.innerHTML=heroCard(ranked[0],why);
    grid.innerHTML=ranked.slice(1).map(supportingCard).join("");
    applying=false;
  }

  function init(){
    const root=document.querySelector(".qb-vibe");
    if(!root)return;

    root.addEventListener("click",event=>{
      if(!event.target.closest(".qb-vibe__choice"))return;
      queueMicrotask(applyContext);
      setTimeout(applyContext,120);
    });

    const hero=root.querySelector("#qb-vibe-hero");
    const grid=root.querySelector("#qb-vibe-products");
    const observer=new MutationObserver(()=>{
      if(!applying)queueMicrotask(applyContext);
    });
    if(hero)observer.observe(hero,{childList:true,subtree:true});
    if(grid)observer.observe(grid,{childList:true,subtree:true});
  }

  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
  document.addEventListener("shopify:section:load",init);
})();
